var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workstation-screen-canvas stage"},[(_vm.isDebug)?_c('pre',{staticClass:"debug"},[_vm._v(_vm._s({ width: _vm.width, height: _vm.height, scale: _vm.scale }))]):_vm._e(),_vm._v(" "),_c('ui5-card',[_c('v-stage',{ref:"stage",attrs:{"config":{
                width: _vm.width * _vm.scale,
                height: _vm.height * _vm.scale,
                scaleX: _vm.scale,
                scaleY: _vm.scale,
            }},on:{"dragstart":_vm.onDragstart,"dragend":_vm.onDragend}},[(_vm.backgroundImage)?_c('v-layer',{ref:"backgroundLayer"},[_c('v-image',{attrs:{"config":_vm.backgroundConfig}})],1):_vm._e(),_vm._v(" "),_c('v-layer',{key:'itemsLayerKey.' + _vm.itemsLayerKey,ref:"layer"},_vm._l((_vm.screenItems),function(item){return _c('v-group',{key:item.id,attrs:{"config":{
                        id: item.id.toString(),
                        x: item.left,
                        y: item.top,
                        draggable: _vm.isDraggable,
                        name: 'Group',
                    }},on:{"mousemove":_vm.onItemMouseOver,"mouseout":_vm.onItemMouseOut}},[(
                            item.type == _vm.TYPE_SPECIAL &&
                            item.key == 'product.image'
                        )?[_c('v-image',{ref:'itemProductImage.' + item.id,refInFor:true,attrs:{"config":_vm.getProductImageConfig(item)},on:{"transformend":function($event){return _vm.handleTransformEnd($event, item)}}}),_vm._v(" "),(_vm.handleDragstart && _vm.handleDragend)?_c('v-transformer',{ref:'transformer.' + item.id,refInFor:true,attrs:{"config":{ rotateEnabled: false }}}):_vm._e()]:(_vm.isValidItem(item))?[_c('v-text',{attrs:{"config":{
                                text: _vm.getScreenItemLabel(item) + ':',
                                fontSize: item.fontSize,
                                fontStyle: item.fontStyle,
                                fontFamily: _vm.UNICODE_FONTS,
                                fill: item.color,
                                x: 0,
                                y: 0,
                            }}}),_vm._v(" "),_c('v-text',{attrs:{"config":{
                                text:
                                    item.value == undefined
                                        ? 'waarde'
                                        : item.value,
                                fontSize: item.fontSize * 2.4,
                                fontStyle: item.fontStyle,
                                fontFamily: _vm.UNICODE_FONTS,
                                fill: item.color,
                                x: 0,
                                y: item.fontSize * 0.9,
                            }}}),_vm._v(" "),(item.valueDescription)?_c('v-text',{attrs:{"config":{
                                text: item.valueDescription,
                                fontSize: item.fontSize * 1.0,
                                fontStyle: item.fontStyle,
                                fontFamily: _vm.UNICODE_FONTS,
                                fill: item.color,
                                x: 0,
                                y: item.fontSize * 3.6,
                            }}}):_vm._e(),_vm._v(" "),(item.showCheckbox)?_c('v-path',{attrs:{"config":{
                                x: 1 - item.fontSize * 4.0,
                                y: 1 - item.fontSize * 0.7,
                                scaleX: item.fontSize * 0.17,
                                scaleY: item.fontSize * 0.17,
                                stroke: 'black',
                                strokeWidth: 1,
                                data: item.selected
                                    ? _vm.checkedPath
                                    : _vm.uncheckedPath,
                            }}}):_vm._e(),_vm._v(" "),(item.showCheckbox)?_c('v-rect',{attrs:{"config":{
                                x: 1 - item.fontSize * 3.5,
                                y: 1 - item.fontSize * 0.1,
                                width: item.fontSize * 3.0,
                                height: item.fontSize * 3.0,
                                fill: item.selected
                                    ? 'transparent'
                                    : 'transparent',
                                strokeWidth: 1,
                                stroke: 'transparent',
                            }},on:{"mousemove":_vm.onCheckboxMouseOver,"mouseout":_vm.onCheckboxMouseOut,"click":function($event){return _vm.onCheckBoxClick(item)},"touchend":function($event){return _vm.onCheckBoxClick(item)}}}):_vm._e()]:_vm._e()],2)}),1)],1)],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }